(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/utils/wrong-charity-dialog.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/utils/wrong-charity-dialog.js');
"use strict";


const showWrongCharityDialog = () => {
  svs.ui.dialog.api.add(new svs.ui.dialog.Confirm({
    branding: svs.ui.dialog.branding.TUR,
    icon: 'exclamation-sign',
    type: svs.ui.dialog.type.DEFAULT,
    title: 'Organisationen hittas inte',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: 'Tyvärr är den här organisationen inte längre möjlig att välja. Vi hoppas att du hittar en annan organisation att stötta.'
    }],
    actions: [{
      title: 'Jag förstår'
    }]
  }));
};
setGlobal('svs.lyckoplatsen.components.shared_charity.utils', {
  showWrongCharityDialog
});

 })(window);